import { render, staticRenderFns } from "./MoneyField2.vue?vue&type=template&id=ce83a8fa&scoped=true"
import script from "./MoneyField2.vue?vue&type=script&lang=ts"
export * from "./MoneyField2.vue?vue&type=script&lang=ts"
import style0 from "./MoneyField2.vue?vue&type=style&index=0&id=ce83a8fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce83a8fa",
  null
  
)

export default component.exports